// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"98":"2adecc7f","114":"c1b0cb17","137":"76f3d3cf","190":"146bbf2c","521":"30c763e8","639":"3efe99b8","762":"3dc46334","884":"b03de3d0"}[chunkId] + ".chunk.css";
};